var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysLoyaltyCardsSuccess = function SvgSysLoyaltyCardsSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M9.18 17.073H4.505a1.713 1.713 0 0 1-1.263-.48 1.61 1.61 0 0 1-.49-1.235V6.217a1.61 1.61 0 0 1 .49-1.235 1.714 1.714 0 0 1 1.263-.48h14.61c1.03 0 2.337.708 2.337 1.715v9.143c0 1.007-1.308 1.714-2.338 1.714H14.44M2.752 7.93h18.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "m14.439 19.93-2.922-1.714L9.18 19.93v-12h5.259v12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4BAF4F",
    d: "M19.675 8.071a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m21.175 3.5-2.062 2-.938-1"
  })));
};
export default SvgSysLoyaltyCardsSuccess;